<template>
    <Modal v-if="showModal" @hide="closeModal">
        <div class="modal-child">
            <h2 class="modal-child__title">{{ title }}</h2>
            <p class="modal-child__content modal-child__content--green">{{ text }}</p>
            <div class="modal-child__actions">
                <button v-if="declineBtn" class="btn btn--txt" @click="handleDecline">
                    {{ declineBtn.text }}
                </button>

                <button v-if="acceptBtn" class="btn btn--cta" @click="handleAccept">
                    {{ acceptBtn.text }}
                </button>
            </div>
        </div>
    </Modal>
</template>

<script>
    import { ref, watch } from 'vue';
    import { useStore } from 'vuex';
    import Modal from '@components/Modal/Modal.vue';

    export default {
        components: {
            Modal,
        },
        setup() {
            const store = useStore();
            const showModal = ref(false);
            const title = ref('');
            const text = ref('');
            const acceptBtn = ref({});
            const declineBtn = ref({});

            watch(
                store.getters['GlobalModalStore/GET_STATE'],
                (newState) => {
                    showModal.value = newState.show;
                    title.value = newState.title;
                    text.value = newState.text;
                    acceptBtn.value = newState.acceptBtn;
                    declineBtn.value = newState.declineBtn;
                },
                { immediate: true }
            );

            const closeModal = () => {
                store.commit('GlobalModalStore/CLEAR_STATE');
            };

            const handleAccept = () => {
                if (acceptBtn.value.fn) {
                    acceptBtn.value.fn();
                }
                closeModal();
            };

            const handleDecline = () => {
                if (declineBtn.value.fn) {
                    declineBtn.value.fn();
                }
                closeModal();
            };

            return {
                closeModal,
                showModal,
                title,
                text,
                acceptBtn,
                declineBtn,
                handleAccept,
                handleDecline,
            };
        },
    };
</script>
